export default __webpack_public_path__ + "static/media/Work_order_Line.0bd056f6.svg";